<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="items"
      sort-by="name"
      :search="search"
      class="elevation-0 general-table"
      :loading="isLoading"
      @click:row="itemEdit"
      :loading-text="$t('GLOBAL-LOADING-PLEASE_WAIT')"
    >
      <template v-slot:header.name="{ header }">
        <lang t="DERIVATION_RULES-CONSTANTS-TBL-HEADER-NAME"></lang>
      </template>
      <template v-slot:header.datatype="{ header }">
        <lang t="DERIVATION_RULES-CONSTANTS-TBL-HEADER-DATA_TYPE"></lang>
      </template>
      <template v-slot:header.value="{ header }">
        <lang t="DERIVATION_RULES-CONSTANTS-TBL-HEADER-VALUE"></lang>
      </template>

      <template v-slot:top>
        <div class="d-flex align-center flex-wrap py-2 mb-3">
          <v-text-field
            clearable
            class="general-table__search"
            v-model="search"
            prepend-inner-icon="mdi-magnify"
            :label="$t('GLOBAL-DO_SEARCH')"
            solo
            flat
            dense
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>

          <Button type="outside-label" icon="mdi-plus" :label="$t('DERIVATION_RULES-CONSTANTS-BTN-NEW_CONSTANT')" @click="itemAdd" />
        </div>
      </template>

      <template v-slot:footer.page-text="props" v-if="items.length > 0">
        <display-number :number="props.pageStart" />-<display-number :number="props.pageStop" /> {{ $t("of") }}
        <display-number :number="items.length" />
      </template>

      <template v-slot:item.name="{ item }">
        {{ item.name }}
      </template>

      <template v-slot:item.datatype="{ item }">
        {{ item.datatype }}
      </template>

      <template v-slot:item.value="{ item }">
        {{ item.value }}
      </template>

      <template v-slot:item.actions="{ item }"></template>

      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>

    <v-dialog v-model="dialog.show" max-width="640px" :persistent="false">
      <v-card>
        <v-card-title>
          <span class="title1"><lang :t="dialog.title"></lang></span>
        </v-card-title>

        <v-card-text>
          <v-text-field :label="$t('DERIVATION_RULES-CONSTANTS-NAME')" v-model="editedItem.name"></v-text-field>
          <v-row>
            <v-col>
              <v-select :items="dataTypes" v-model="editedItem.datatype" :label="$t('DERIVATION_RULES-CONSTANTS-DATA_TYPE')"></v-select>
            </v-col>
            <v-col>
              <v-text-field
                :label="$t('DERIVATION_RULES-CONSTANTS-VALUE')"
                :type="editedItem.datatype == 'number' ? 'number' : 'text'"
                v-model.number="editedItem.value"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeModal" :disabled="dialog.isSaving"><lang t="GLOBAL-BTN-CANCEL"></lang></v-btn>
          <v-btn elevation="0" class="general-action-btn" :loading="dialog.isSaving" @click="itemSave()"><lang t="GLOBAL-BTN-SAVE"></lang></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Button from "../../../components/ui-elements/Button.vue";
import DisplayNumber from "../../../components/DisplayNumber.vue";

export default {
  name: "TabConstants",
  components: {
    Button,
    DisplayNumber,
  },
  data: () => ({
    isSaving: false,
    isLoading: true,
    search: "",

    headers: [
      { text: "Name", align: "start", value: "name", sortable: true, class: "general-table__th--3" },
      { text: "DataType", align: "start", value: "datatype", sortable: true, class: "general-table__th--3" },
      { text: "Value", align: "start", value: "value", sortable: true, class: "general-table__th--3" },
      { text: "", value: "actions", sortable: false, width: "80px" },
    ],

    items: [],

    dialog: {
      show: false,
      title: "",
      isSaving: false,
    },
    dataTypes: [
      {
        text: "String",
        value: "string",
      },
      {
        text: "Number",
        value: "number",
      },
    ],

    editedIndex: -1,
    editedItem: {
      id: null,
      name: "",
      datatype: null,
      value: null,
    },
    defaultItem: {
      id: null,
      name: "",
      datatype: null,
      value: null,
    },
  }),

  watch: {
    "dialog.show"(val) {
      val || this.closeModal();
    },
  },

  computed: {},
  created() {
    this.init();
  },

  methods: {
    init() {
      this.$axios.get("constants").then((res) => {
        this.items = res.data;
        setTimeout(() => {
          this.isLoading = false;
        }, 1000);
      });
    },
    itemEdit(item) {
      this.dialog.title = this.$t("DERIVATION_RULES-CONSTANTS-EDIT_CONSTANT");
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);

      this.dialog.show = true;
    },

    itemAdd() {
      this.dialog.title = this.$t("DERIVATION_RULES-CONSTANTS-NEW_CONSTANT");
      this.dialog.show = true;
    },

    itemSave() {
      if (this.editedItem.name == "" || this.editedItem.datatype == null || this.editedItem.value == null) {
        this.$store.dispatch("setSnackbar", {
          text: this.$t("GLOBAL-MESSAGE-PLEASE_FILL_OUT_ALL_FIELDS"),
          type: "warning",
        });
        return;
      }

      this.dialog.isSaving = true;

      let requestType = "";
      let requestURL = "constants";

      if (this.editedItem.id != null) {
        requestType = "put";
        requestURL += "/" + this.editedItem.id;
      } else {
        requestType = "post";
      }

      this.axios[requestType](requestURL, this.editedItem)
        .then((res) => {
          this._fin();
        })
        .catch((error) => {
          this._err(error.response);
        });
    },

    _fin() {
      this.$store.dispatch("setSnackbar", {
        text: this.$t("GLOBAL-MESSAGE-SUCCESSFULLY_SAVED"),
      });
      this.closeModal(true);
    },
    _err(error) {
      this.dialog.isSaving = false;
      this.$store.dispatch("setSnackbar", {
        text: "ERROR " + error.status + ": " + error.data.message,
        type: "error",
      });
    },

    closeModal(refresh = false) {
      this.dialog.show = false;
      this.dialog.fullscreen = false;
      this.dialog.isSaving = false;
      this.isSaving = false;

      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      });
      if (refresh === true) {
        this.init();
      }
    },
  },
};
</script>

<style lang="scss"></style>
